module.exports = __webpack_public_path__ + "img/info-img3.0992fab5.jpg";